import React, { useCallback, useMemo, useState } from 'react';
import { Button, Modal, Tabs } from 'antd';
import { useAuth } from '../../context/AuthContext';
import LedgerList from './LedgerList';
import MyApplicationsList from './MyApplicationsList';
import NewLeaveApplicationForm from './NewLeaveApplicationForm';
import OvertimeApplicationForm from './OvertimeApplicationForm';
import './LeaveOvertimePage.css';

const { TabPane } = Tabs;

const LeaveOvertimePage = () => {
  const auth = useAuth();
  const roles = useMemo(() => (Array.isArray(auth?.user?.roles) ? auth.user.roles : []), [auth?.user?.roles]);
  const isMobile = useMemo(() => window.matchMedia && window.matchMedia('(max-width: 768px)').matches, []);

  const [activeKey, setActiveKey] = useState('my');
  const [leaveModalOpen, setLeaveModalOpen] = useState(false);
  const [overtimeModalOpen, setOvertimeModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const canViewLedger = useMemo(() => {
    const allowed = new Set([
      'HR',
      'ProjectManager',
      'DeputyManager',
      'project_manager',
      'deputy_manager',
      '项目经理',
      '项目负责人',
      '项目主管',
      '副经理'
    ]);
    return roles.some((r) => allowed.has(r));
  }, [roles]);

  const handleSubmitted = useCallback(() => {
    setRefreshKey((v) => v + 1);
    setActiveKey('my');
  }, []);

  return (
    <div className="leave-overtime-page">
      <div className="leave-overtime-header">
        <div className="leave-overtime-title">请假加班</div>
        <div className="leave-overtime-actions">
          <Button type="primary" block={isMobile} onClick={() => setLeaveModalOpen(true)}>
            新建请假申请
          </Button>
          <Button block={isMobile} onClick={() => setOvertimeModalOpen(true)}>
            新建加班申请
          </Button>
        </div>
      </div>

      <Tabs activeKey={activeKey} onChange={setActiveKey} size="large" className="leave-overtime-tabs">
        {canViewLedger && (
          <TabPane tab="台账列表" key="ledger">
            <LedgerList />
          </TabPane>
        )}
        <TabPane tab="我的申请" key="my">
          <MyApplicationsList refreshKey={refreshKey} />
        </TabPane>
      </Tabs>

      <Modal
        title="请假申请"
        open={leaveModalOpen}
        onCancel={() => setLeaveModalOpen(false)}
        footer={null}
        destroyOnClose
        centered={!isMobile}
        width={isMobile ? '100vw' : 900}
        wrapClassName={isMobile ? 'native-fullscreen-modal' : undefined}
      >
        <NewLeaveApplicationForm onSubmitted={handleSubmitted} onClose={() => setLeaveModalOpen(false)} />
      </Modal>

      <Modal
        title="加班申请"
        open={overtimeModalOpen}
        onCancel={() => setOvertimeModalOpen(false)}
        footer={null}
        destroyOnClose
        centered={!isMobile}
        width={isMobile ? '100vw' : 900}
        wrapClassName={isMobile ? 'native-fullscreen-modal' : undefined}
      >
        <OvertimeApplicationForm onSubmitted={handleSubmitted} onClose={() => setOvertimeModalOpen(false)} />
      </Modal>
    </div>
  );
};

export default LeaveOvertimePage;